// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__22Bt7","bigColWidth":"Table_bigColWidth__1ycFi","biggerColWidth":"Table_biggerColWidth__1lQoc","row":"Table_row__1s-8e","col":"Table_col__kq6g_"};